export default "__VITE_ASSET__DwfKspqb__";